<template>
  <div class="pa-page">
    <div class="pa-card">

      <!-- Logo -->
      <div class="pa-logo">
        <img src="/logo-booster.png" alt="VSLBooster" style="height:36px" />
      </div>

      <!-- Loading -->
      <div v-if="loading" class="pa-loading">
        <div class="pa-spinner"></div>
        <p>Validando seu acesso...</p>
      </div>

      <!-- Token invalido -->
      <div v-else-if="error" class="pa-error">
        <div class="pa-error-icon">⚠️</div>
        <h2>Link invalido ou expirado</h2>
        <p>Este link de ativacao ja foi usado ou expirou. Se voce ja criou sua senha, faca login normalmente.</p>
        <router-link to="/login" class="pa-btn">Ir para o login</router-link>
      </div>

      <!-- Formulario de criar senha -->
      <div v-else-if="!done" class="pa-form">
        <h2 class="pa-title">Ola {{ userName }}! 👋</h2>
        <p class="pa-sub">Crie sua senha para acessar a plataforma.</p>

        <div class="pa-field">
          <label class="pa-label">Email</label>
          <input type="email" :value="userEmail" class="pa-input" disabled />
        </div>

        <div class="pa-field">
          <label class="pa-label">Criar senha</label>
          <input v-model="password" type="password" class="pa-input" placeholder="Minimo 6 caracteres" @keyup.enter="submit" />
        </div>

        <div class="pa-field">
          <label class="pa-label">Confirmar senha</label>
          <input v-model="confirmPassword" type="password" class="pa-input" placeholder="Repita a senha" @keyup.enter="submit" />
        </div>

        <p v-if="formError" class="pa-form-error">{{ formError }}</p>

        <button class="pa-btn" @click="submit" :disabled="submitting">
          {{ submitting ? 'Salvando...' : 'Criar senha e entrar' }}
        </button>
      </div>

      <!-- Sucesso -->
      <div v-else class="pa-success">
        <div class="pa-success-icon">✅</div>
        <h2>Senha criada com sucesso!</h2>
        <p>Voce ja pode acessar a plataforma.</p>
        <router-link to="/login" class="pa-btn">Fazer login</router-link>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PrimeiroAcesso',
  data() {
    return {
      loading: true,
      error: false,
      done: false,
      submitting: false,
      formError: '',
      token: '',
      userName: '',
      userEmail: '',
      userId: null,
      password: '',
      confirmPassword: '',
    }
  },
  mounted() {
    this.token = this.$route.query.token || ''
    if (!this.token) {
      this.error = true
      this.loading = false
      return
    }
    this.validateToken()
  },
  methods: {
    api() { return process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend' },
    async validateToken() {
      try {
        const resp = await fetch(`${this.api()}/primeiro-acesso/validar`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: this.token }),
        })
        const data = await resp.json()
        if (resp.ok && data.valid) {
          this.userName = (data.user_name || '').split(' ')[0]
          this.userEmail = data.user_email
          this.userId = data.user_id
        } else {
          this.error = true
        }
      } catch {
        this.error = true
      } finally {
        this.loading = false
      }
    },
    async submit() {
      this.formError = ''
      if (!this.password || this.password.length < 6) {
        this.formError = 'Senha deve ter no minimo 6 caracteres'
        return
      }
      if (this.password !== this.confirmPassword) {
        this.formError = 'As senhas nao conferem'
        return
      }
      this.submitting = true
      try {
        const resp = await fetch(`${this.api()}/primeiro-acesso/definir-senha`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: this.token, password: this.password }),
        })
        const data = await resp.json()
        if (resp.ok && data.ok) {
          this.done = true
        } else {
          this.formError = data.error || 'Erro ao definir senha'
        }
      } catch (e) {
        this.formError = 'Erro de conexao'
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>

<style scoped>
.pa-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #0D1B2E 0%, #0a2240 60%, #06192e 100%);
  padding: 24px;
}
.pa-card {
  background: #fff;
  border-radius: 20px;
  padding: 48px 40px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 32px 80px rgba(0,0,0,0.3);
}
.pa-logo { text-align: center; margin-bottom: 32px; }
.pa-title { font-size: 22px; font-weight: 800; color: #0f172a; margin: 0 0 8px; }
.pa-sub { font-size: 14px; color: #64748b; margin: 0 0 24px; line-height: 1.5; }

.pa-field { margin-bottom: 18px; }
.pa-label { display: block; font-size: 12px; font-weight: 700; color: #334155; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; }
.pa-input {
  width: 100%; padding: 12px 16px; border: 1.5px solid #d1d5db; border-radius: 10px;
  font-size: 14px; color: #0f172a; background: #f8fafc; outline: none;
  transition: border-color 0.2s, box-shadow 0.2s; box-sizing: border-box;
}
.pa-input:focus { border-color: #E86A10; box-shadow: 0 0 0 3px rgba(232,106,16,0.12); background: #fff; }
.pa-input:disabled { background: #f1f5f9; color: #64748b; }

.pa-btn {
  display: block; width: 100%; padding: 14px; border: none; border-radius: 12px;
  background: linear-gradient(135deg, #E86A10, #d45e0c); color: #fff;
  font-size: 15px; font-weight: 700; cursor: pointer; text-align: center; text-decoration: none;
  box-shadow: 0 8px 24px rgba(232,106,16,0.3); transition: all 0.2s; margin-top: 8px;
}
.pa-btn:hover { transform: translateY(-1px); box-shadow: 0 12px 32px rgba(232,106,16,0.4); }
.pa-btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }

.pa-form-error { color: #EF4444; font-size: 13px; font-weight: 500; margin-bottom: 12px; }

.pa-loading { text-align: center; padding: 32px 0; color: #64748b; }
.pa-spinner { width: 32px; height: 32px; border-radius: 50%; border: 3px solid #e2e8f0; border-top-color: #E86A10; animation: pa-spin 0.7s linear infinite; margin: 0 auto 16px; }
@keyframes pa-spin { to { transform: rotate(360deg); } }

.pa-error, .pa-success { text-align: center; padding: 16px 0; }
.pa-error-icon, .pa-success-icon { font-size: 48px; margin-bottom: 16px; }
.pa-error h2, .pa-success h2 { font-size: 20px; font-weight: 800; color: #0f172a; margin: 0 0 8px; }
.pa-error p, .pa-success p { font-size: 14px; color: #64748b; line-height: 1.6; margin: 0 0 24px; }
</style>
